/** Jenis kontrak kerja karyawan */
export const CONTRACT_TYPES = ['PKWT', 'PKWTT', 'Project', 'Freelance', 'Magang'];

const ALIASES = {
  pkwt: 'PKWT',
  pkwtt: 'PKWTT',
  project: 'Project',
  proyek: 'Project',
  freelance: 'Freelance',
  freelancers: 'Freelance',
  magang: 'Magang',
  pkl: 'Magang',
  intern: 'Magang',
  internship: 'Magang',
};

/**
 * Normalisasi nilai jenis kontrak ke salah satu opsi resmi.
 * Mengembalikan string kosong jika kosong/tidak dikenal (kecuali strict).
 */
export function normalizeContractType(value, { fallback = '' } = {}) {
  const raw = String(value || '').trim();
  if (!raw) return fallback;
  if (CONTRACT_TYPES.includes(raw)) return raw;
  const mapped = ALIASES[raw.toLowerCase()];
  return mapped || fallback;
}

export function contractTypeLabel(value) {
  return normalizeContractType(value) || '—';
}

const CONTRACT_MARKER_RE = /\[\[CT:([^\]]*)\]\]/g;

/** Sisipkan penanda jenis kontrak ke catatan HRD — dipakai API lama yang belum map contractType. */
export function encodeContractTypeMarker(notes, contractType) {
  const cleaned = String(notes || '').replace(CONTRACT_MARKER_RE, '').trim();
  const normalized = normalizeContractType(contractType);
  const marker = `[[CT:${normalized}]]`;
  return cleaned ? `${marker}\n${cleaned}` : marker;
}

export function decodeContractTypeMarker(notes) {
  const match = String(notes || '').match(/\[\[CT:([^\]]*)\]\]/);
  return normalizeContractType(match ? match[1] : '');
}

export function stripContractTypeMarker(notes) {
  const cleaned = String(notes || '').replace(CONTRACT_MARKER_RE, '').trim();
  return cleaned;
}
